"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dvcDefaultLogger = exports.DVCLogLevels = void 0;
var isNumber_1 = __importDefault(require("lodash/isNumber"));
var prefix = '[DevCycle]: ';
var DVCLogLevels;
(function (DVCLogLevels) {
    DVCLogLevels[DVCLogLevels["debug"] = 0] = "debug";
    DVCLogLevels[DVCLogLevels["info"] = 1] = "info";
    DVCLogLevels[DVCLogLevels["warn"] = 2] = "warn";
    DVCLogLevels[DVCLogLevels["error"] = 3] = "error";
})(DVCLogLevels || (exports.DVCLogLevels = DVCLogLevels = {}));
function dvcDefaultLogger(options) {
    var minLevel = (options === null || options === void 0 ? void 0 : options.level) && (0, isNumber_1.default)(DVCLogLevels[options === null || options === void 0 ? void 0 : options.level])
        ? DVCLogLevels[options === null || options === void 0 ? void 0 : options.level]
        : DVCLogLevels.error;
    var logWriter = (options === null || options === void 0 ? void 0 : options.logWriter) || console.log;
    var errorWriter = (options === null || options === void 0 ? void 0 : options.logWriter) || console.error;
    var writeLog = function (message) { return logWriter(prefix + message); };
    var writeError = function (message, error) {
        return errorWriter(prefix + message, error);
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    var noOpLog = function (message) { };
    return {
        error: DVCLogLevels.error >= minLevel ? writeError : noOpLog,
        warn: DVCLogLevels.warn >= minLevel ? writeLog : noOpLog,
        info: DVCLogLevels.info >= minLevel ? writeLog : noOpLog,
        debug: DVCLogLevels.debug >= minLevel ? writeLog : noOpLog,
    };
}
exports.dvcDefaultLogger = dvcDefaultLogger;
//# sourceMappingURL=logger.js.map